import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import EditProfile from './editProfile';
import AudiLog from './audiLog';

const AudiLogUpadte = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();

  const [activeEdit, setEditActive] = useState(false);

  useEffect(() => {
    pathname === '/editProfile' ? setEditActive(true) : setEditActive(false);
  }, [pathname]);

  const handlePageChange = (page: string) => {
    if (pathname !== page) {
      navigate(page);
    }
  };

  return (
    <>
      <div className="audilog_update">
        <Button
          className={activeEdit ? 'activeEdit' : ''}
          onClick={() => handlePageChange('/editProfile')}
        >
          Edit Profile
        </Button>
        <Button
          className={!activeEdit ? 'activeEdit' : ''}
          onClick={() => handlePageChange('/auditlogupdate')}
        >
          Audit Log
        </Button>
      </div>
      {activeEdit ? <EditProfile /> : <AudiLog />}
    </>
  );
};

export default AudiLogUpadte;
